import Balancer from "react-wrap-balancer";
import Markdown from "markdown-to-jsx";

import { SubHeading } from "./components/subHeading";
import Carousel from "./components/carousel";
import TextButton from "components/textButton/TextButtonLegacy";
import { Faq } from "components/faq/faq";
import type { NewslettersPageData } from "lib/types/newsletters";
import { useMappedNewsletters } from "lib/hooks/useMappedNewsletters";
import dynamic from "next/dynamic";
const NewsletterSection = dynamic(
  () => import("components/newsletterHubV2/NewsletterSection"),
  {
    ssr: false,
  }
);

const NewsletterHubView = ({ data }: { data: NewslettersPageData }) => {
  const { featuredNewsletter, secondaryFeaturedNewsletter, newsletterList } =
    useMappedNewsletters();
  return (
    <main data-page-type="newsletters" className="overflow-hidden">
      <div className="bg-mono-05">
        <div className="wrapper relative px-5 lg:px-[45px]">
          <div className="max-w-[1220px] pb-[70px] pt-7 md:pt-32 lg:mx-auto lg:w-full">
            <div className="mb-[40px] md:mb-[50px] lg:mb-[60px]">
              <h1 className="text-center font-recklessBold text-[26px] leading-[130%] md:block md:text-[32px] lg:text-[52px]">
                <Balancer>{data.heading}</Balancer>
              </h1>
            </div>

            {newsletterList.length > 0 && (
              <NewsletterSection
                featured={featuredNewsletter}
                weekend={secondaryFeaturedNewsletter}
                newsletters={newsletterList}
                columns={newsletterList.length > 5 ? 6 : 5}
              />
            )}

            <SubHeading data={data} />
          </div>
        </div>
      </div>

      <div className="wrapper relative px-5 lg:px-[45px]">
        <div className="max-w-[1220px] pb-[100px] lg:mx-auto lg:w-full">
          <div className="mt-[60px] md:mt-0">
            <div className="mb-3 mt-[70px] text-center font-recklessBold text-[26px] leading-[130%] md:block md:text-[32px] [&_strong]:text-cerise">
              <Markdown>{data.carouselSectionHeading}</Markdown>
            </div>

            <Carousel slides={data.testimonials} />
          </div>

          <div>
            <h3 className="block font-recklessBold text-[32px] lg:hidden">
              {data.faqSectionTitle}
            </h3>
            <div className="flex flex-col-reverse lg:flex-row lg:justify-between lg:gap-x-6">
              <div className="">
                <h3 className="hidden font-recklessBold text-[32px] lg:block">
                  {data.faqSectionTitle}
                </h3>
                <div className="mt-[40px] flex flex-col space-y-[26px] lg:mt-[30px]">
                  {data.faqLinks.map((link, i) => {
                    return (
                      <TextButton
                        key={i}
                        href={link.url}
                        colour="black"
                        withIcon
                        className="w-max-content"
                      >
                        {link.text}
                      </TextButton>
                    );
                  })}
                </div>
              </div>

              <Faq faq={data.faq} />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NewsletterHubView;
